import React from 'react'

function About() {
    return (
        <div>
    
    <h1>Hey there! I am the about page.</h1>    
    <h2>I am visible to all users</h2>

        </div>
    )
}

export default About;